import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionContractApi = {
    getTrialInstitutionContractByTrialInstitutionId: (trialInstitutionId: number): Observable<Dtos.GetTrialInstitutionContractByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionContractByTrialInstitutionId = new Dtos.GetTrialInstitutionContractByTrialInstitutionId();
        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionContractByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionContractById: (id: number): Observable<Dtos.GetTrialInstitutionContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionContractById = new Dtos.GetTrialInstitutionContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionContract: (trialInstitutionContract: Dtos.TrialInstitutionContract): Observable<Dtos.SetTrialInstitutionContractResponse> => {

        let request: Dtos.SetTrialInstitutionContract = new Dtos.SetTrialInstitutionContract();

        request.trialInstitutionContract = trialInstitutionContract;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialInstitutionContract: (trialInstitutionId: number): Observable<Dtos.CreateTrialInstitutionContractResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionContract = new Dtos.CreateTrialInstitutionContract();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionContract: (trialInstitutionContract: Dtos.TrialInstitutionContract): Observable<Dtos.ValidateTrialInstitutionContractResponse> => {

        let request: Dtos.ValidateTrialInstitutionContract = new Dtos.ValidateTrialInstitutionContract();

        request.trialInstitutionContract = trialInstitutionContract;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionContractResponse> = client.post(request);

        return Observable.from(response);
    },
    deleteTrialInstitutionContract: (id: number): Observable<Dtos.DeleteTrialInstitutionContractResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialInstitutionContract = new Dtos.DeleteTrialInstitutionContract();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialInstitutionContractResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}